const toBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = event => resolve(event.target.result);
    reader.onerror = () => reject(new Error(`Não foi possível ler o arquivo ${file.name}`));

    return reader.readAsDataURL(file);
  });

export default toBase64;
